import { render } from "./LabTestPanelsPage.vue?vue&type=template&id=f5062774"
import script from "./LabTestPanelsPage.vue?vue&type=script&lang=js"
export * from "./LabTestPanelsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__